import Cookie from 'js-cookie'


export default {
    state: {
        token:'',
        isLogin:false,
        // userLoginInfo:[]
        headImg:'',
        isTeacher:'',
        name:'',
        openId:'',
        refreshToken:'',
        refreshTokenExpires:'',
        token:'',
        userId:'',
        userVip:'',
        type:2 //1是立刻学习已经登录   2是免费学习，还没登录    3是VIP课程   登录之后要刷新该变量的状态
        
    },
    mutations: {
        setUserLoginInfo(state){
            console.log(11111)
            Cookie.set('userLoginInfo',state.token,{
                expires:state.refreshTokenExpires
            })
        },
        clearUserLoginInfo(state){
            state.token = ''
            Cookie.remove('userLoginInfo')
        },
        getUserLoginInfo(){
            state.token = Cookie.get('token')
        },
        changeLogin(state,val){
            // if(state.token.length == 0){
            //     state.No_Login = true
            // }else {
            //     state.No_Login = false
            // }
            state.isLogin = val
        },
        setUserLoginInfo(state,val){
            console.log(2222)
            state.headImg = val.headImg
            state.isTeacher = val.isTeacher
            state.name = val.name
            state.openId = val.openId
            state.refreshToken = val.refreshToken
            state.refreshTokenExpires = val.refreshTokenExpires
            state.token = val.token
            state.userId = val.userId
            state.userVip = val.userVip
            state.loginstatus = val.type
            Cookie.set('token',state)
        }

    },
    actions: {
        changeLoginState({ commit }){
            commit('changeLogin',true)
        },
        SaveLoginInfo({ commit },userInfo){
             commit('setUserLoginInfo',userInfo)
        }
    }
}